import type { SVGProps } from "react";
export interface TagsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TagsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TagsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.058 2.701a1.125 1.125 0 0 1 1.59 1.59L4.846 8.097a5.875 5.875 0 0 0 0 8.309l3.802 3.804.078.085a1.126 1.126 0 0 1-1.582 1.582l-.087-.076-3.802-3.805a8.125 8.125 0 0 1 0-11.49zm.146 5.503a1.126 1.126 0 0 1 1.506-.077l.085.077 8 8 .077.086a1.124 1.124 0 0 1-1.582 1.582l-.085-.077-8.001-8-.076-.085a1.125 1.125 0 0 1 .076-1.506"
      />
      <path
        fill={color}
        d="M20.875 4.5a.375.375 0 0 0-.375-.375h-5.257c-.436 0-.855.151-1.188.425l-.138.124L7.67 10.92a1.875 1.875 0 0 0 0 2.652l3.757 3.757c.732.732 1.92.732 2.651 0l6.247-6.246.124-.138c.273-.333.425-.753.425-1.188V4.5Zm-1.5 2.5a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141a1.375 1.375 0 0 1 1.366-1.235l.141.007c.694.07 1.235.656 1.235 1.368m3.75 2.757c0 .958-.333 1.881-.935 2.615l-.274.302-6.246 6.246a4.124 4.124 0 0 1-5.833 0L6.08 15.163a4.124 4.124 0 0 1 0-5.833l6.246-6.247.302-.273a4.13 4.13 0 0 1 2.615-.935H20.5A2.625 2.625 0 0 1 23.125 4.5z"
      />
    </svg>
  );
}
